import { render } from "./npxTable.vue?vue&type=template&id=78977fee&ts=true"
import script from "./npxTable.vue?vue&type=script&lang=ts"
export * from "./npxTable.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__